import React, { useEffect, useRef, useState, useMemo } from 'react';
import {
  MapContainer,
  Marker,
  Tooltip,
  ImageOverlay,
  useMap,
} from 'react-leaflet';
import { LatLngTuple } from 'leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import SelectedAssetMetricsReadDto, { GroupDetailsDto, GatewayDetailsDto } from '../../../../../Models/Dashboard/SelectedAssetMetricsReadDto';
import AssetImageReadDto from '../../../../../Models/Assets/AssetImageReadDto';
import { GREASE_PUMP_LEAFLET_ICON_URL_BLUE } from '../../../../../Utilities/CustomIcons';

const greenPinSvg = encodeURIComponent(`
  <svg width="30" height="36" viewBox="0 0 37 44" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.5 2C10.5 2 4 8.5 4 16.5C4 28.5 18.5 42 18.5 42C18.5 42 33 28.5 33 16.5C33 8.5 26.5 2 18.5 2Z" fill="#3FA43F" stroke="white" stroke-width="1"/>
    <circle cx="18.5" cy="16.5" r="5" fill="white"/>
  </svg>
`);

const redPinSvg = encodeURIComponent(`
  <svg width="30" height="36" viewBox="0 0 37 44" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.5 2C10.5 2 4 8.5 4 16.5C4 28.5 18.5 42 18.5 42C18.5 42 33 28.5 33 16.5C33 8.5 26.5 2 18.5 2Z" fill="#FF3630" stroke="white" stroke-width="1"/>
    <circle cx="18.5" cy="16.5" r="5" fill="white"/>
  </svg>
`);

const greyPinSvg = encodeURIComponent(`
  <svg width="30" height="36" viewBox="0 0 37 44" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.5 2C10.5 2 4 8.5 4 16.5C4 28.5 18.5 42 18.5 42C18.5 42 33 28.5 33 16.5C33 8.5 26.5 2 18.5 2Z" fill="#85868E" stroke="white" stroke-width="1"/>
    <circle cx="18.5" cy="16.5" r="5" fill="white"/>
  </svg>
`);

const orangePinSvg = encodeURIComponent(`
  <svg width="30" height="36" viewBox="0 0 37 44" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.5 2C10.5 2 4 8.5 4 16.5C4 28.5 18.5 42 18.5 42C18.5 42 33 28.5 33 16.5C33 8.5 26.5 2 18.5 2Z" fill="#FFBF00" stroke="white" stroke-width="1"/>
    <circle cx="18.5" cy="16.5" r="5" fill="white"/>
  </svg>
`);

/** Gateway device icon path (GetGatewayHMEIcon) - used inside colored pins */
const gatewayDevicePath = 'M 28.838544 17.785683 C 25.623218 17.785683 23.008466 20.400924 23.008466 23.615761 L 23.008466 56.693886 C 23.008466 59.837225 25.508277 62.399977 28.6237 62.514199 L 28.6237 64.266152 C 28.6237 65.278626 29.564669 66.058195 30.959638 66.297402 L 30.959638 70.619667 C 30.959638 71.172401 31.407392 71.619667 31.959638 71.619667 C 32.51237 71.619667 32.959638 71.172401 32.959638 70.619667 L 32.959638 66.37748 L 35.326825 66.37748 L 35.326825 70.619667 C 35.326825 71.172401 35.774093 71.619667 36.326825 71.619667 C 36.87956 71.619667 37.326825 71.172401 37.326825 70.619667 L 37.326825 66.297402 C 38.716621 66.056299 39.652997 65.276353 39.652997 64.266152 L 39.652997 62.523964 L 46.053388 62.523964 L 46.053388 64.266152 C 46.053388 65.278171 46.993439 66.057815 48.387372 66.297402 L 48.387372 70.619667 C 48.387372 71.172401 48.834639 71.619667 49.387372 71.619667 C 49.940106 71.619667 50.387372 71.172401 50.387372 70.619667 L 50.387372 66.37748 L 52.75456 66.37748 L 52.75456 70.619667 C 52.75456 71.172401 53.201826 71.619667 53.75456 71.619667 C 54.307292 71.619667 54.75456 71.172401 54.75456 70.619667 L 54.75456 66.297402 C 56.144355 66.056299 57.080732 65.276353 57.080732 64.266152 L 57.080732 62.449745 C 59.878097 62.023028 62.02995 59.609543 62.02995 56.693886 L 62.02995 23.615761 C 62.02995 20.400924 59.414709 17.785683 56.199872 17.785683 L 28.838544 17.785683 z M 28.838544 20.135292 L 56.199872 20.135292 C 58.118813 20.135292 59.680341 21.69682 59.680341 23.615761 L 59.680341 56.693886 C 59.680341 58.613804 58.118813 60.174355 56.199872 60.174355 L 28.838544 60.174355 C 26.919115 60.174355 25.358075 58.613804 25.358075 56.693886 L 25.358075 23.615761 C 25.358075 21.69682 26.919115 20.135292 28.838544 20.135292 z M 42.518232 33.273964 C 39.135426 33.273964 35.958658 34.586469 33.572919 36.973183 C 33.113937 37.433144 33.113937 38.178263 33.572919 38.637245 C 34.033857 39.096229 34.777998 39.096229 35.236982 38.637245 C 37.178384 36.694866 39.765308 35.625527 42.520185 35.625527 C 45.275062 35.625527 47.861986 36.694866 49.803388 38.637245 C 50.03288 38.866737 50.334638 38.982949 50.635419 38.982949 C 50.936194 38.982949 51.237959 38.866737 51.46745 38.637245 C 51.926434 38.177286 51.926434 37.433144 51.46745 36.973183 C 49.080737 34.587445 45.90299 33.273964 42.520185 33.273964 L 42.518232 33.273964 z M 42.520185 39.008339 C 40.671556 39.008339 38.934243 39.728068 37.62956 41.031777 C 37.170575 41.491736 37.170575 42.23588 37.62956 42.695839 C 37.887737 42.954017 38.237207 43.066002 38.574872 43.03373 C 38.837501 43.008629 39.092817 42.896645 39.293622 42.695839 C 39.349164 42.640236 39.405885 42.585858 39.463544 42.53373 C 41.250985 40.917769 44.022996 40.972149 45.744794 42.695839 C 45.85954 42.810585 45.993696 42.896157 46.135419 42.953652 C 46.17085 42.968026 46.206439 42.981928 46.242841 42.992714 C 46.279243 43.0035 46.31513 43.01091 46.352216 43.018105 C 46.389302 43.025299 46.428012 43.032084 46.465497 43.035683 C 46.502982 43.039282 46.539228 43.039589 46.576825 43.039589 C 46.877606 43.039589 47.179365 42.925331 47.408857 42.695839 C 47.86784 42.23588 47.86784 41.491736 47.408857 41.031777 C 46.104172 39.728068 44.368814 39.008339 42.520185 39.008339 z M 42.520185 44.453652 C 41.808002 44.453652 41.229169 45.03293 41.229169 45.744667 C 41.229169 46.455997 41.808002 47.035683 42.520185 47.035683 C 43.231477 47.035683 43.809247 46.455997 43.809247 45.744667 C 43.809247 45.03293 43.231477 44.453652 42.520185 44.453652 z M 30.84831 53.773964 C 30.166911 53.808606 29.6237 54.375485 29.6237 55.06498 C 29.6237 55.776308 30.202535 56.354042 30.914716 56.354042 C 31.626007 56.354042 32.205732 55.776308 32.205732 55.06498 C 32.205732 54.353244 31.626007 53.773964 30.914716 53.773964 C 30.89246 53.773964 30.87029 53.772847 30.84831 53.773964 z M 38.586591 53.773964 C 37.905193 53.808606 37.361982 54.375485 37.361982 55.06498 C 37.361982 55.776308 37.940815 56.354042 38.652997 56.354042 C 39.36429 56.354042 39.94206 55.776308 39.94206 55.06498 C 39.94206 54.353244 39.36429 53.773964 38.652997 53.773964 C 38.630742 53.773964 38.608572 53.772847 38.586591 53.773964 z M 46.324872 53.773964 C 45.643474 53.808606 45.100263 54.375485 45.100263 55.06498 C 45.100263 55.776308 45.679096 56.354042 46.391278 56.354042 C 47.102571 56.354042 47.680341 55.776308 47.680341 55.06498 C 47.680341 54.353244 47.102571 53.773964 46.391278 53.773964 C 46.369024 53.773964 46.346853 53.772847 46.324872 53.773964 z M 54.0612 53.773964 C 53.379803 53.808606 52.838544 54.375485 52.838544 55.06498 C 52.838544 55.776308 53.415424 56.354042 54.127607 56.354042 C 54.838898 56.354042 55.418622 55.776308 55.418622 55.06498 C 55.418622 54.353244 54.838898 53.773964 54.127607 53.773964 C 54.105351 53.773964 54.083181 53.772847 54.0612 53.773964 z M 30.6237 62.523964 L 37.652997 62.523964 L 37.652997 64.098183 C 37.487958 64.205605 37.057292 64.37748 36.395185 64.37748 L 31.881513 64.37748 C 31.219406 64.37748 30.789227 64.205605 30.6237 64.098183 L 30.6237 62.523964 z M 48.053388 62.523964 L 55.080732 62.523964 L 55.080732 64.098183 C 54.915693 64.205605 54.485027 64.37748 53.822919 64.37748 L 49.3112 64.37748 C 48.649093 64.37748 48.218427 64.205605 48.053388 64.098183 L 48.053388 62.523964 z';

const gatewayPinGreenSvg = encodeURIComponent(`
  <svg width="30" height="36" viewBox="0 0 37 44" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.5 2C10.5 2 4 8.5 4 16.5C4 28.5 18.5 42 18.5 42C18.5 42 33 28.5 33 16.5C33 8.5 26.5 2 18.5 2Z" fill="#3FA43F" stroke="white" stroke-width="1"/>
    <g transform="translate(10, 7) scale(0.42)"><path fill="white" stroke="white" stroke-width="1" d="${gatewayDevicePath}" transform="translate(-23.008466,-17.785683)"/></g>
  </svg>
`);

const gatewayPinRedSvg = encodeURIComponent(`
  <svg width="30" height="36" viewBox="0 0 37 44" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.5 2C10.5 2 4 8.5 4 16.5C4 28.5 18.5 42 18.5 42C18.5 42 33 28.5 33 16.5C33 8.5 26.5 2 18.5 2Z" fill="#FF3630" stroke="white" stroke-width="1"/>
    <g transform="translate(10, 7) scale(0.42)"><path fill="white" stroke="white" stroke-width="1" d="${gatewayDevicePath}" transform="translate(-23.008466,-17.785683)"/></g>
  </svg>
`);

const gatewayPinOrangeSvg = encodeURIComponent(`
  <svg width="30" height="36" viewBox="0 0 37 44" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.5 2C10.5 2 4 8.5 4 16.5C4 28.5 18.5 42 18.5 42C18.5 42 33 28.5 33 16.5C33 8.5 26.5 2 18.5 2Z" fill="#FFBF00" stroke="white" stroke-width="1"/>
    <g transform="translate(10, 7) scale(0.42)"><path fill="white" stroke="white" stroke-width="1" d="${gatewayDevicePath}" transform="translate(-23.008466,-17.785683)"/></g>
  </svg>
`);

const gatewayPinGreySvg = encodeURIComponent(`
  <svg width="30" height="36" viewBox="0 0 37 44" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.5 2C10.5 2 4 8.5 4 16.5C4 28.5 18.5 42 18.5 42C18.5 42 33 28.5 33 16.5C33 8.5 26.5 2 18.5 2Z" fill="#85868E" stroke="white" stroke-width="1"/>
    <g transform="translate(10, 7) scale(0.42)"><path fill="white" stroke="white" stroke-width="1" d="${gatewayDevicePath}" transform="translate(-23.008466,-17.785683)"/></g>
  </svg>
`);

const GreenIcon = L.icon({
  iconUrl: "data:image/svg+xml," + greenPinSvg,
  iconSize: [30, 36],
  iconAnchor: [15, 36],
});

const RedIcon = L.icon({
  iconUrl: "data:image/svg+xml," + redPinSvg,
  iconSize: [30, 36],
  iconAnchor: [15, 36],
});

const OrangeIcon = L.icon({
  iconUrl: "data:image/svg+xml," + orangePinSvg,
  iconSize: [30, 36],
  iconAnchor: [15, 36],
});

const GreyIcon = L.icon({
  iconUrl: "data:image/svg+xml," + greyPinSvg,
  iconSize: [30, 36],
  iconAnchor: [15, 36],
});

const GreasePumpIcon = L.icon({
  iconUrl: GREASE_PUMP_LEAFLET_ICON_URL_BLUE,
  iconSize: [30, 36],
  iconAnchor: [15, 36],
});

const GatewayPinGreenIcon = L.icon({
  iconUrl: "data:image/svg+xml," + gatewayPinGreenSvg,
  iconSize: [30, 36],
  iconAnchor: [15, 36],
});

const GatewayPinRedIcon = L.icon({
  iconUrl: "data:image/svg+xml," + gatewayPinRedSvg,
  iconSize: [30, 36],
  iconAnchor: [15, 36],
});

const GatewayPinOrangeIcon = L.icon({
  iconUrl: "data:image/svg+xml," + gatewayPinOrangeSvg,
  iconSize: [30, 36],
  iconAnchor: [15, 36],
});

const GatewayPinGreyIcon = L.icon({
  iconUrl: "data:image/svg+xml," + gatewayPinGreySvg,
  iconSize: [30, 36],
  iconAnchor: [15, 36],
});

interface MarkerData {
  id: number | string;
  stringId?: string; // For grease pumps: original id for comparison (handles UUIDs)
  position: {
    xPos: number;
    yPos: number;
  };
  name: string;
  compliance: string;
  connectivity: string;
  type: 'group' | 'greasePump' | 'gateway';
}

interface Props {
  onMarkersChange?: (markers: MarkerData[]) => void;
  selectedGroupId: number | null;
  selectedGreasePumpId?: string | null; // From endpoint.greasePumpId when endpoint is selected
  onMarkerSelect?: (groupId: number | null) => void;
  assetData: SelectedAssetMetricsReadDto;
  imageData: AssetImageReadDto;
}

const calculateMinZoom = (
  imageWidth: number,
  imageHeight: number,
  containerWidth: number,
  containerHeight: number
): number => {
  const zoomX = Math.log2(containerWidth / imageWidth);
  const zoomY = Math.log2(containerHeight / imageHeight);
  return Math.min(zoomX, zoomY);
};

const FitImageMap = ({
  bounds,
  minZoom,
  onReady,
}: {
  bounds: L.LatLngBoundsExpression;
  minZoom: number;
  onReady?: () => void;
}) => {
  const map = useMap();

  useEffect(() => {
    if (!map) return;

    map.setMinZoom(minZoom);
    map.setMaxBounds(bounds);

    if (map.getZoom() !== minZoom) {
      map.setZoom(minZoom);
    }

    map.panTo(map.getCenter());

    if (onReady) onReady();
  }, [map, bounds, minZoom]);

  return null;
};

const getMarkerIcon = (compliance: string, connectivity: string) => {

  const getStatusPriority = (status: string) => {
    switch (status) {
      case "NonCompliant":
      case "Offline":
        return 3;
      case "PartiallyCompliant":
      case "Partial":
        return 2;
      case "Compliant":
      case "Online":
        return 1;
      default:
        return 0; // Unknown or other statuses
    }
  };

  // Get the worst status between compliance and connectivity
  const compliancePriority = getStatusPriority(compliance);
  const connectivityPriority = getStatusPriority(connectivity);
  const worstPriority = Math.max(compliancePriority, connectivityPriority);

  // Return icon based on the worst status
  switch (worstPriority) {
    case 3: // NonCompliant or Offline
      return RedIcon;
    case 2: // PartiallyCompliant or PartialConnected
      return OrangeIcon;
    case 1: // Compliant or Online
      return GreenIcon;
    default: // Unknown or other
      return GreyIcon;
  }
};

const getGatewayMarkerIcon = (compliance: string, connectivity: string) => {
  const getStatusPriority = (status: string) => {
    switch (status) {
      case "Offline": return 3;
      case "Partial": return 2;
      case "Online": return 1;
      default: return 0;
    }
  };
  const worstPriority = Math.max(getStatusPriority(compliance), getStatusPriority(connectivity));
  switch (worstPriority) {
    case 3: return GatewayPinRedIcon;
    case 2: return GatewayPinOrangeIcon;
    case 1: return GatewayPinGreenIcon;
    default: return GatewayPinGreyIcon;
  }
};

const ImageComponent: React.FC<Props> = ({
  onMarkersChange,
  selectedGroupId,
  selectedGreasePumpId = null,
  onMarkerSelect,
  assetData,
  imageData,
}) => {

  const containerRef = useRef<HTMLDivElement>(null);
  const [imageSize, setImageSize] = useState<{ width: number; height: number } | null>(null);
  const [minZoom, setMinZoom] = useState<number | null>(null);
  const [loading, setLoading] = useState(true);
  const [markers, setMarkers] = useState<MarkerData[]>([]);
  const mapRef = useRef<any>(null);

  // Load image and get its dimensions
  useEffect(() => {
    if (!imageData?.data) return;

    const img = new Image();
    img.src = imageData.data;
    img.onload = () => {
      setImageSize({ width: img.width, height: img.height });
    };
  }, [imageData?.data]);

  // Create markers
  useEffect(() => {
    const isGreasePumpEnabled = assetData?.assetConfigurationDetails?.isGreasePumpConnectivityEnabled ?? false;
    
    const groupMarkers: MarkerData[] =
      assetData?.assetConfigurationDetails?.groups?.map((group: GroupDetailsDto) => ({
        id: parseInt(group.id),
        position: {
          xPos: group.xPos,
          yPos: group.yPos
        },
        name: group.name || `Group ${group.id}`,
        compliance: group.complianceStatus || "Unknown",
        connectivity: group.connectivityStatus || "Unknown",
        type: 'group' as const,
      })) || [];

    const greasePumpMarkers: MarkerData[] = isGreasePumpEnabled
      ? assetData?.assetConfigurationDetails?.greasePumps?.map((greasePump: any, index: number) => ({
          id: parseInt(greasePump.id) || index,
          stringId: greasePump.id, // Preserve original id for comparison with endpoint.greasePumpId
          position: {
            xPos: greasePump.xPos || (100 + index * 50), // Default position if not provided
            yPos: greasePump.yPos || (100 + index * 50), // Default position if not provided
          },
          name: greasePump.name || `Grease Pump ${greasePump.id}`,
          compliance: "Unknown", // Grease pumps don't have compliance status in the API
          connectivity: "Unknown", // Grease pumps don't have connectivity status in the API
          type: 'greasePump' as const,
        })) || []
      : [];

    // Gateways with xPos/yPos - color based on connectivity (Online=green, Offline=red, Partial=orange, Unknown=grey)
    const gatewayMarkers: MarkerData[] =
      assetData?.assetConfigurationDetails?.gateways
        ?.filter((gw: GatewayDetailsDto) => gw.xPos != null && gw.yPos != null)
        ?.map((gw: GatewayDetailsDto) => ({
          id: `gateway_${gw.id}`,
          position: { xPos: gw.xPos!, yPos: gw.yPos! },
          name: gw.name || gw.serialNumber || `Gateway ${gw.id}`,
          compliance: gw.compliance || "Unknown",
          connectivity: gw.connectivity || "Unknown",
          type: 'gateway' as const,
        })) || [];

    setMarkers([...groupMarkers, ...greasePumpMarkers, ...gatewayMarkers]);
  }, [assetData]);

  // Use ResizeObserver to track container size changes
  useEffect(() => {
    if (!containerRef.current || !imageSize) return;

    const observer = new ResizeObserver((entries) => {
      for (let entry of entries) {
        const { width, height } = entry.contentRect;
        const newMinZoom = calculateMinZoom(
          imageSize.width,
          imageSize.height,
          width,
          height
        );

        // Apply an offset to the zoom level

        const zoomOffset = 0.05;  // Adjust this offset to your needs

        const adjustedZoom = newMinZoom - zoomOffset; // Decrease the zoom level slightly
 

        // Update minZoom only if it has changed
        setMinZoom((prev) => (prev !== adjustedZoom ? adjustedZoom : prev));
      }
    });

    observer.observe(containerRef.current);

    return () => observer.disconnect();
  }, [imageSize]);

  useEffect(() => {
    if (mapRef.current) {
      mapRef.current.invalidateSize();
    }
  }, [imageSize, minZoom]);

  const ready = imageSize && minZoom !== null;

  const bounds = useMemo(
    () =>
      [
        [0, 0],
        [imageSize?.height || 0, imageSize?.width || 0],
      ] as [[number, number], [number, number]],
    [imageSize]
  );

  const markerElements = useMemo(
    () =>
      markers.map((marker) => {
        const icon = marker.type === 'greasePump' 
          ? GreasePumpIcon 
          : marker.type === 'gateway'
            ? getGatewayMarkerIcon(marker.compliance, marker.connectivity)
            : getMarkerIcon(marker.compliance, marker.connectivity);
        // Only group markers respond to selectedGroupId for opacity (avoids grease pump
        // appearing "selected" when it shares the same numeric ID as the selected group)
        const isGroupSelected = marker.type === 'group' && selectedGroupId === marker.id;
        // Grease pump: highlight when selectedGreasePumpId (from endpoint) matches
        const isGreasePumpSelected = marker.type === 'greasePump' && selectedGreasePumpId && (marker.stringId === selectedGreasePumpId || marker.id.toString() === selectedGreasePumpId);
        const markerOpacity = marker.type === 'gateway'
          ? 1 // Gateways always full opacity (not selectable)
          : marker.type === 'greasePump'
            ? (selectedGreasePumpId ? (isGreasePumpSelected ? 1 : 0.4) : 1)
            : (selectedGroupId === null ? 1 : (isGroupSelected ? 1 : 0.4));
        
        const isClickable = marker.type === 'group';
        
        return (
          <Marker
            key={`${marker.type}-${marker.stringId ?? marker.id}`}
            position={[marker.position.yPos, marker.position.xPos] as LatLngTuple}
            {...{ opacity: markerOpacity } as any}
            icon={icon}
            eventHandlers={isClickable ? {
              click: () => {
                if (selectedGroupId === marker.id) {
                  onMarkerSelect?.(null); // Deselect all
                } else {
                  onMarkerSelect?.(marker.id as number); // Select this marker
                }
              }
            } : {}}
          >
            <Tooltip 
              direction="top" 
              offset={[0, -20]}
              className={isGroupSelected || isGreasePumpSelected ? "selected-marker-tooltip" : ""}
            >
              <div className={`text-center font-semibold ${isGroupSelected || isGreasePumpSelected ? 'text-[#305FE6]' : ''}`}>
                {marker.name}
              </div>
            </Tooltip>
          </Marker>
        );
      }),
    [markers, selectedGroupId, selectedGreasePumpId, onMarkerSelect]
  );

  // Add effect to notify parent of marker changes
  useEffect(() => {
    if (onMarkersChange) {
      onMarkersChange(markers);
    }
  }, [markers, onMarkersChange]);

  return (
    <div className="w-full h-full relative" ref={containerRef}>
      {loading && (
        <div className="absolute inset-0 z-20 flex items-center justify-center bg-white bg-opacity-60">
          <div className="loader border-4 border-gray-300 border-t-blue-500 rounded-full w-12 h-12 animate-spin" />
        </div>
      )}

      {ready && (
        <MapContainer
          ref={mapRef}
          crs={L.CRS.Simple}
          zoom={minZoom!}
          minZoom={minZoom!}
          maxZoom={4}
          dragging={true}
          doubleClickZoom={false}
          scrollWheelZoom={true}
          zoomControl={false}
          style={{ height: '100%', width: '100%', backgroundColor: 'transparent' }}
          bounds={bounds}
          maxBounds={bounds}
          //Zoom snapping for adjusting the zoom level when resizing the image
          zoomSnap={0.1}
          zoomAnimation={false}
          fadeAnimation={false}
        >
          <ImageOverlay url={imageData.data} bounds={bounds} />
          <FitImageMap bounds={bounds} minZoom={minZoom!} onReady={() => setLoading(false)} />
          {markerElements}
        </MapContainer>
      )}
    </div>
  );
};

export default ImageComponent;
